// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"N7-z","dimensionLabel":"O7-z","styleChooserControlWrapper":"P7-z","styleChooserControl":"Q7-z","disabled":"R7-z","giftCard":"S7-z","styleChooserText":"T7-z"};